import {
  compareWithInitVal,
  fieldDataTypes,
} from '../../../../../../shared/lib/formFieldValidators';

export const getValidationRules = ({ initialValue, editMode }) => {
  const requiredRule = {
    required: true,
    message: 'Укажите причину',
    type: 'number',
  };

  return editMode
    ? [
        requiredRule,
        { validator: compareWithInitVal(initialValue, fieldDataTypes.number) },
      ]
    : [requiredRule];
};
